import React from 'react';
import classnames from 'classnames';
import RcSlider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

// Node module repo for rc-slider -> https://github.com/react-component/slider

export default function Slider({
  id,
  name,
  choices,
  className,
  defaultValue,
  disabled,
  value,
  onChange,
}) {

  // Returns a hash containing the choices evenly distributed
  // exa: 3 choices
  // { 0: 'choice 1', 50: 'choice 2', 100: 'choice 3 }

  const getMarks = (choices) => {
    if (!choices.length) return {};
    const step = 100/(choices.length -1)
    const marks = {};
    choices.map((choice, i) => {
      const content = choice.text;
      const choiceText = $(content).text();
      if (choices.length >= 6) {
        marks[step*(choice.position - 1)] = {'label': `${choiceText}`, 'style': {'inlineSize': '55px', 'overflowWrap': 'break-word'}}
      } else {
        marks[step*(choice.position - 1)] = {'label': `${choiceText}`, 'style': {'inlineSize': '120px', 'overflowWrap': 'break-word'}}
      }
    });
    return marks;
  };
  return (
    <div>
      <input type="hidden" name={name} id={name} />
      <RcSlider
        className={classnames('icmib-slider', className)}
        min={0}
        onChange={onChange}
        defaultValue={null}
        marks={getMarks(choices)}
        step={null}
        trackStyle={{ backgroundColor: '#e9e9e9' }}
      />
    </div>
  );
}
